import React from 'react';
import api from '../api';
import { Typography } from '@material-ui/core';
import AddPromo from './addPromo';

export default function Promo() {
    const [promo, setPromo] = React.useState([])
    const [visibleCreate, setVisibleCreate] = React.useState(false)
    const getPromo = () => {
        api.create().getPromo().then(response => {
            console.log(response.data.data)
            setPromo(response.data.data)
        })
    }
    React.useEffect(() => {
        getPromo()
    }, [])

    const onClose = () => {
        setVisibleCreate(false)
    }
    console.log(promo);
    return (
        <div style={{ paddingTop: 20, }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                    onClick={() => setVisibleCreate(true)}
                >
                    <div style={{ display: 'flex' }}>
                        <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                        <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 8, color: 'white' }}>Tambah Promo</Typography>
                    </div>
                </button>
            </div>
            <div style={{margin: 'auto', width: "60%", height: '50%'}}>
                {promo && promo.map((el, idx) => {
                    return (
                        <div>
                            <img style={{width: 200, height: 100}} src={el.background_url} />
                            <h1>{el.content}</h1>
                            <p>{el.subtitle}</p>
                            <a href={el.url}>see detail</a>
                        </div>
                    )
                })}
            </div>

            {visibleCreate ?
                <AddPromo
                    onClose={onClose}
                /> : null}
        </div>
    )
}